import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateUploadFile = {
  uploadFile: { data: null, loading: false, error: null },
};

export const uploadFile = createAsyncThunk('user/uploadFile', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .post(`/upload/file`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUploadFile = {
  [uploadFile.pending]: (state) => {
    state.uploadFile.loading = true;
  },
  [uploadFile.fulfilled]: (state, action) => {
    state.uploadFile.loading = false;
    state.uploadFile.data = action.payload;
    state.uploadFile.error = null;
  },
  [uploadFile.rejected]: (state, action) => {
    state.uploadFile.data = null;
    state.uploadFile.loading = false;
    state.uploadFile.error = action.payload;
  },
};
